import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order, PaymentSubmission, PostOrder } from '@core/models';
import { API_LIST } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private httpClient: HttpClient) {}

  getUserOrder(id: string): Observable<Order> {
    return this.httpClient.get<Order>(API_LIST.getUserOrder(id));
  }

  postOrderPayment(
    id: string,
    submissionData: PaymentSubmission
  ): Observable<PostOrder> {
    return this.httpClient.post<PostOrder>(
      API_LIST.postOrderPayment(id),
      submissionData
    );
  }
}
